// Safe to ignore: store.getState() is only called at runtime, not during module initialization
import store from '../reducers/storeRegistration'; // eslint-disable-line import/no-cycle

//  tried to use the getUser from '../components/common/classes/permissions', but this
//  triggers loading of createHashHistory which causes a 'Invariant Violation: Hash history needs
//  a DOM' error when running tests
const getUser = () => {
  const _store$getState = store.getState(),
    login = _store$getState.login;
  return login && login.user || {};
};

// Retrieve user's permissions (general, summaries & reportTypes)
const getPermissions = () => {
  const user = getUser();
  if (user.permissions === undefined) {
    user.permissions = {};
  }
  if (user.permissions.adminSubsections === undefined) {
    user.permissions.adminSubsections = [];
  }
  if (user.permissions.adminSections === undefined) {
    user.permissions.adminSections = [];
  }
  return user.permissions;
};
const hasPermission = (permissionType, permission) => {
  const permissions = getPermissions()[permissionType];
  return permissions ? permissions.includes(permission) : false;
};
const hasAdminSectionPermission = perm => hasPermission('adminSections', perm);
const hasAdminSubSectionPermission = perm => hasPermission('adminSubsections', perm);
export { getUser, getPermissions, hasPermission, hasAdminSectionPermission, hasAdminSubSectionPermission };